// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LayoutTwoToneSvg from "@fishx/icons-svg/es/asn/LayoutTwoTone";
import FishxIcon from '../components/FishxIcon';

var LayoutTwoTone = function LayoutTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LayoutTwoToneSvg
  }));
};

LayoutTwoTone.displayName = 'LayoutTwoTone';
export default React.forwardRef(LayoutTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LayoutTwoTone.js
// module id = 3013
// module chunks = 0